import React from 'react';

function RecipeCard({ recipe }) {
  return (
    <div className="recipe-card" style={{
      padding: '12px',
      backgroundColor: '#fff',
      border: '1px solid #e0e0e0',
      borderRadius: '6px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: '500',
      color: '#333',
      textAlign: 'center',
      wordBreak: 'break-word'
    }}>
      {recipe.name}
    </div>
  );
}

export default RecipeCard;
